import type { PopupType } from './types';
import { mutations as TYPES } from './types';
import { State } from './state';

const mutations = {
  /**
   * Reset
   * @param state ..
   * @param state.show ..
   */
  [TYPES.RESET](_state: State) {
    _state = new State();
  },
  [TYPES.TOGGLE_GLOADING]: (state: State, data: { active: boolean; text: string }) => {
    state.gloading.active = data.active;
    state.gloading.text = data.text;
  },
  [TYPES.OPEN_POPUP]: (state: State, data: PopupType) => {
    state.popups.push({
      id: data.type + '::' + Date.now(),
      ...data,
    });
  },
  [TYPES.CLOSE_POPUP]: (state: State, id: string) => {
    const index = state.popups.findIndex((x) => x.id == id);
    if (index > -1) {
      state.popups.splice(index, 1);
    }
  },
  [TYPES.SET_SHOW_DROPDOWN]: (state: State, showDropdown: boolean) => {
    state.showDropdown = showDropdown;
  },
};

export default mutations;
